import { render, staticRenderFns } from "./OptionSelector.vue?vue&type=template&id=5e4f5a0a&"
import script from "./OptionSelector.vue?vue&type=script&lang=js&"
export * from "./OptionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports